import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';

export const materialLookupNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('materialLookup'),
    controlValues: z.object({
        enabledProperties: z.object({
            materialId: z.boolean().default(true),
            modelNumber: z.boolean().default(true),
            className: z.boolean().default(true),
            materialStatus: z.boolean().default(true),
            openConcernCount: z.boolean().default(true),
            closedConcernCount: z.boolean().default(true),
            latestConcernText: z.boolean().default(true),
            incompleteProcessCount: z.boolean().default(true),
            completedProcessCount: z.boolean().default(true),
            expectedProcessCount: z.boolean().default(true),
            incompleteWorkInstructionCount: z.boolean().default(true),
            completedWorkInstructionCount: z.boolean().default(true),
            linkedWorkInstructionCount: z.boolean().default(true),
        }).partial().optional(),
    }).optional(),
});
export interface MaterialLookupNodeCfgSchema extends z.infer<typeof materialLookupNodeCfgSchema> {}

export const materialLookupNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({
            trigger: 'event',
        }),
        outputs: () => ({
            next: 'event',
        }),
    },
    dataSockets: {
        inputs: () => ({
            serialNumber: 'string',
        }),
        outputs: () => ({
            materialId: 'string',
            modelNumber: 'string',
            className: 'string',
            materialStatus: 'string',
            openConcernCount: 'number',
            closedConcernCount: 'number',
            latestConcernText: 'string',
            incompleteProcessCount: 'number',
            completedProcessCount: 'number',
            expectedProcessCount: 'number',
            incompleteWorkInstructionCount: 'number',
            completedWorkInstructionCount: 'number',
            linkedWorkInstructionCount: 'number',
        }),
    },
} satisfies NodeSocketCfg<MaterialLookupNodeCfgSchema>;
